import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { typeM } from 'src/app/Models/BasicForms/typeM';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-type-master',
  templateUrl: './type-master.component.html',
  styleUrls: ['./type-master.component.css']
})

export class TypeMasterComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Type";

  ngOnInit(): void {
    this.getAllType();

    this.logtext = 'OPENED - Type Master form KEYWORD[O - Type Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["NAME", "Type"], ["ICON", "Icon"]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  typeData: [];

  getAllType(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Type Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Type Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Type Master form "+ likeQuery +" KEYWORD [F - Type Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    var filter = ""
    if (likeQuery)
      filter = this.filterQuery + likeQuery
    else
      filter = this.filterQuery


    this.isloadSpinning = true

    this._apiService.getAllType(this.pageIndex, this.pageSize, this.sortKey, sort, filter).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.typeData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  drawerVisible = false;
  drawerTitle = "";
  typeDrawerData: typeM = new typeM();
  add() {
    this.drawerVisible = true;
    this.drawerTitle = "Create Type";
    this.typeDrawerData = new typeM();
    this.typeDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Type Master form KEYWORD [A - Type Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: typeM) {
    this.drawerVisible = true;
    this.drawerTitle = "Update Type";
    this.typeDrawerData = Object.assign({}, data);

    this.logtext = 'EDIT - Type Master form KEYWORD [E - Type Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAllType();
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  sortKey: string = "id";
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllType();
  }
}
